var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { OfficeLocationStub } from '../../offices/index.js';
import { OfficeAchievementGiftCodeFullSizeDto } from './office-achievement-gift-code.full-size.dto.js';
import { OfficeAchievementLevelFullSizeDto } from './office-achievement-level.full-size.dto.js';
export class OfficeAchievementFullSizeDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    officeLocation;
    currentOfficeAchievementLevelId;
    currentOfficeAchievementLevel;
    officeAchievementLevels;
    officeAchievementGiftCode;
    officeAchievementGiftCodeId;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeLocationStub),
    __metadata("design:type", Function)
], OfficeAchievementFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], OfficeAchievementFullSizeDto.prototype, "currentOfficeAchievementLevelId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    Type(() => OfficeAchievementLevelFullSizeDto),
    __metadata("design:type", Object)
], OfficeAchievementFullSizeDto.prototype, "currentOfficeAchievementLevel", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => OfficeAchievementLevelFullSizeDto),
    __metadata("design:type", Array)
], OfficeAchievementFullSizeDto.prototype, "officeAchievementLevels", void 0);
__decorate([
    Expose(),
    Type(() => OfficeAchievementGiftCodeFullSizeDto),
    __metadata("design:type", Object)
], OfficeAchievementFullSizeDto.prototype, "officeAchievementGiftCode", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeAchievementFullSizeDto.prototype, "officeAchievementGiftCodeId", void 0);
//# sourceMappingURL=office-achievement.full-size.dto.js.map